export default {
  validation: {
    required: '必須項目です。',
    kana_format: '全角カタカナで入力してください',
    email_format: 'メールアドレスの形式が不正です',
    date_format: '正しい日付を入力してください。',
    date_range: '現在から前後{intervalYears}年以内の日付を入力してください。',
    number_format: '数字を入力してください',
    number_range: '{min}〜{max}の値を入力してください。',
    halfwidth_number_format: '半角数字のみで入力してください。',
    alphanumeric_format: '半角英数字で入力してください',
    company_name_format: '会社名に使用できない文字が含まれています。',
    postal_number_no_hyphen: 'ハイフンなしで入力してください',
    postal_number_format: '正しい郵便番号を入力してください',
    login_email_required: '@:validation.required',
    login_email_format: '@:validation.email_format',
    login_password_required: '@:validation.required',
    login_password_format: '6文字以上で入力してください。',
    min_length: '{length}文字以上で入力してください。',
    max_length: '{length}文字以内で入力してください。',
    greater_than_or_equal_number: '{item}以上の数値を入力してください',
    greater_than_number: '{item}より大きい数値を入力してください',
    less_than_or_equal_number: '{item}以下の数値を入力してください',
    less_than_number: '{item}より小さい数値を入力してください',
    greater_than_or_equal_number_with_target: '{target}は{item}以上の数値を入力してください。',
    greater_than_number_with_target: '{target}は{item}より大きい数値を入力してください。',
    less_than_or_equal_number_with_target: '{target}は{item}以下の数値を入力してください。',
    less_than_number_with_target: '{target}は{item}より小さい数値を入力してください。',
    max_digit: '{digit}桁以内で入力してください。',
    max_digit_with_item: '{item}が{digit}桁以内になるように入力してください',
    number_only: '数字のみで入力してください。',
    decimal_max_digit: '小数点第{decimalMaxDigit}位までで入力してください。',
    no_blank_or_newline: '空白や改行のみの入力はできません。',
    invalid_zero_number: '0以外の数値を入力してください',
    outlier_ratio: '過去回答と大きく異なります。',
    variables: {
      // id_or_email: "",
      // email: "",
      // password: "",
      // kana: "",
      // date: "",
      // number: "",
      // alphanumeric: "",
      // postal_number: "",
    },
    not_same_sharing_email: '共有中のメールアドレスと同じメールアドレスは登録できません。',
    not_duplicate_email: '同じメールアドレスは入力できません',
    no_base_locale: '基準言語に登録がないため、記載できません。',
  },
}